import { trustHTML } from "@ember/template";
import getUrl from "discourse/lib/get-url";
import DEmptyState from "discourse/ui-kit/d-empty-state";
import { i18n } from "discourse-i18n";

const ChatNotificationsListEmptyState = <template>
  <DEmptyState
    @body={{trustHTML
      (i18n
        "user_menu.no_chat_notifications_body"
        preferencesUrl=(getUrl "/my/preferences/notifications")
      )
    }}
    @title={{i18n "user_menu.no_chat_notifications_title"}}
  />
</template>;

export default ChatNotificationsListEmptyState;
